import { memo } from 'react'
import { Flash, Star } from '../at-icon'

export interface AtTagProps {
  /** Icon to show: true/'flash' for lightning (instant book), 'star' for featured */
  icon?: boolean | 'flash' | 'star'
  label: string
  className?: string
  /** Visual variant: 'default' (blue), 'onDemand' (orange) */
  variant?: 'default' | 'onDemand'
}

const variantStyles = {
  default: 'bg-secondary-100 text-secondary-700',
  onDemand: 'bg-tertiary-100 text-tertiary-900',
} as const

const AtTagComponent = ({ icon = false, label, className = '', variant = 'default' }: AtTagProps) => {
  const IconComponent = icon === 'star' ? Star : icon ? Flash : null
  return (
    <div
      className={`h-7 inline-flex justify-center items-center rounded-4 font-bold text-12 leading-1.5 uppercase ${
        IconComponent ? 'pl-1.5 pr-2' : 'px-2'
      } ${variantStyles[variant]} ${className}`}
    >
      {IconComponent && <IconComponent className="fill-current mr-1 w-4" />}
      {label}
    </div>
  )
}

export const AtTag = memo(AtTagComponent)
